import { useState } from "react";

import { Button, PlusCircleHollowSVG } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import { Content } from "@tiptap/core";

import { handleInstructionsChange } from "@/assignments/utils/assignmentActions";
import RichTextEditor from "@/components/RichTextEditor";
import { Assignment } from "@/types/models/Assignment.interface";
import useAssignmentReducerContext from "@/view/utils/useAssignmentReducerContext";
import { headingCss } from "./AssignmentInstructionsInput.style";

interface AssignmentInstructionsInputProps {
  isEditorOpen?: boolean;
}

const AssignmentInstructionsInput = ({
  isEditorOpen: forceEditorOpen = false,
}: AssignmentInstructionsInputProps) => {
  const { updatedAssignment, dispatch } = useAssignmentReducerContext() as {
    updatedAssignment: Assignment;
    dispatch: () => void;
  };

  const instructions = updatedAssignment?.instructions;
  const [isEditorOpen, setIsEditorOpen] = useState(forceEditorOpen);
  const ButtonWithTrackEvent = withTrackEvent(Button);

  const handleUpdateInstructions = (instructions: Content) => {
    handleInstructionsChange(instructions, dispatch);
  };

  return (
    <>
      <div css={headingCss}>
        <h2>Instructions</h2>
      </div>
      {isEditorOpen || instructions ? (
        <RichTextEditor
          content={instructions ?? ""}
          onChange={(instructions) => handleUpdateInstructions(instructions)}
        />
      ) : (
        <>
          <ButtonWithTrackEvent
            objectType={objectTypes.assignment}
            actionName={actionNames.update}
            dataProps={{
              "data-qa-selector": "add-instructions-button",
            }}
            flavor={Button.flavors.muted}
            onClick={() => setIsEditorOpen(!isEditorOpen)}
            size={Button.sizes.sm}
            icon={{
              SvgComponent: PlusCircleHollowSVG,
              alignment: Button.iconAlignments.left,
            }}
          >
            Add instructions
          </ButtonWithTrackEvent>
        </>
      )}
    </>
  );
};

export default AssignmentInstructionsInput;
